import React from "react";
import { useTranslation } from "react-i18next";
import StatisticCard from "../components/StatisticCard";
import BasicCheckoutTable from "../components/BasicCheckoutTable";
import ProUpgradeCard from "../components/ProUpgradeCard";

/**
 * Basic Strategies Tab Komponente
 * Zeigt grundlegende Strategien und Checkout-Tabellen
 */
const BasicStrategiesTab = ({ isProMember }) => {
  const { t } = useTranslation();

  return (
    <div className="max-w-4xl mx-auto mt-6">
      {/* Basic Checkout Table */}
      <BasicCheckoutTable />

      {/* Pro Upgrade für erweiterte Strategien */}
      {!isProMember && (
        <div className="mt-8">
          <ProUpgradeCard
            title={t("statistics.basicStrategies.upgradeTitle")}
            description={t("statistics.basicStrategies.upgradeDescription")}
          />
        </div>
      )}
    </div>
  );
};

export default BasicStrategiesTab;
